import { render, staticRenderFns } from "./bulk-message-template-admin.vue?vue&type=template&id=375f13ac&scoped=true&"
import script from "./bulk-message-template-admin.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f13ac",
  null
  
)

export default component.exports